// extracted by mini-css-extract-plugin
export var circle = "_9f-1";
export var exitConfirmationModal = "_9f-5";
export var iframe = "_9f-0";
export var offline = "_9f-3";
export var online = "_9f-2";
export var workstationSelectError = "_9f-4";